

 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

export  const    sectionTheme1InfoCard6Object ={ no:3, 
    id: generateTimestamp()+3,
    cardName:"Theme1InfoCard6",
    cardType:"non-Editable",
 myKey:`id-Theme1InfoCard6-layout`,
  blockType:"layout",
    contents:[
    { contentNo:1, id: generateTimestamp(),itemBackground:{color:"rgba(0, 0, 0, 1)",alpha:1}
          ,itemCards:{  type:"nonEditable"
            ,cards:[
                       ]},myKey:`id-Theme1InfoCard6-layout1`,
          columns:1,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
  blockType:"Card",
 innerBlocks:[],

 customStyle:{
    
 },
 layoutSettings:{
    disableAnimation:false,
     shape1Animation:{title:"Shape Animation",type:"rhombusHL",delay:0.4,
        color: {color:"rgba(35, 36, 36, 0.93)",color1:"rgba(130, 242, 242, 0.93)",color2:"rgba(140, 177, 251, 0.93)",colors:{color10:"rgba(247, 252, 252, 0.93)"},alpha:1}
     ,},
      shape2Animation:{title:"Shape Animation",type:"rhombusHR",delay:0.4,
        color:{color:"rgba(255, 255, 255, 0.93)",color1:"rgba(130, 242, 242, 0.93)",color2:"rgba(140, 177, 251, 0.93)",colors:{color10:"rgba(247, 252, 252, 0.93)"},alpha:1}
     , },
     
     layoutWidth:{value:100,resolution:"%"},
    
     borderRadius1:{title:"Layout BG Radius",value:0,resolution:"px"},
    
     layoutBG:{ title:"Section Card Outer Color",
      color:"rgba(255, 255, 255, 1)",colors:{color3:"rgba(255, 224, 71, 0.3)",color10:"rgba(255, 224, 71, 1)"},alpha:1},
    
 }   },
        { contentNo:2, id: generateTimestamp()+1,itemBackground:{color:"rgba(144, 202, 249, 0.1)",alpha:1}

          ,itemCards:{  type:"nonEditable"
            ,cards:[
               { id: 1,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,  
                title: "Master the Art of Music",subtitle: "Unlock your musical potential with this comprehensive course. Learn theory, rhythm, melody, and composition across styles. ", 
                image: "https://i.postimg.cc/LXZf86jH/college-girls-studying-together.jpg",
                video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=qFLhGq0060w",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }, },
              { id: 2,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,
                  title: " Learn, Play, Create",subtitle: "Explore the world of music through engaging lessons in theory.", 
                image: "https://i.postimg.cc/6qL2rhJb/youngsters-listening-music-university.jpg" ,
               video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=Bn-3ICGjz0U",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       },},
              { id: 3,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,
                  title: "Learn at Your Pace",subtitle: "Master the basics of music with a blend of theory, practice, and creativity.", 
                image: "https://i.postimg.cc/50JF6rDQ/students-posing-selfie-outside.jpg",
                video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=UZwi9SHgzGY",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }, },
                                      
                      { id: 4,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,
                  title: "Learn at Your Pace",subtitle: "Master the basics of music with a blend of theory, practice, and creativity.", 
                image: "https://i.postimg.cc/t4YRDRbd/6390.jpg",
                video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=UZwi9SHgzGY",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }, },  
                                         { id: 5,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,
                  title: "Learn at Your Pace",subtitle: "Master the basics of music with a blend of theory, practice, and creativity.", 
                image: "https://i.postimg.cc/HkNtgpwZ/6408.jpg",
                video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=UZwi9SHgzGY",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"",hideThumbnail:false,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }, },
                       ]},myKey:`id-Theme1InfoCard6-layout2`,columns:4,fontFamily:{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 },
  blockType:"images",
 customStyle:{
    
 },
 layoutSettings:{
    flexDirection:"row",
   
    gap:10,
    flexWrap:"nowrap",
    justifyContent:"center",
    alignItems:"center",
    layoutWidth:{value:100,resolution:"%"},
item1Width:{value:100,resolution:"%"},

    disableAnimation:false,
     layoutAnimation:{title:"Layout Animation",type:"slideLeftZoom",delay:0.4},
  item1Animation:{title:"Title   Animation",type:"zoomIn",delay:0.4},
  item2Animation:{title:"Subtitle  Animation",type:"zoomIn",delay:0.4},
   item3Animation:{title:"Left Section  Animation",type:"zoomIn",delay:0.4},
  item4Animation:{title:"Images Animation",type:"slideLeftZoom",delay:0.4},
  item5Animation:{title:"Slide Carousel Animation",type:"slideLeftRotate",delay:0.4},
  item6Animation:{title:"Player Animation",type:"slideLeftZoom",delay:0.4},
   
     borderRadius1:{title:"Layout Radius",topLeft:{title:"Text Box Radius",value:150,resolution:"px"},topRight:{title:"Text Box Radius",value:10,resolution:"px"},
    bottomLeft:{title:"Text Box Radius",value:30,resolution:"px"},bottomRight:{title:"Text Box Radius",value:50,resolution:"px"}},
     borderRadius2:{title:"Play Button Radius",topLeft:{title:"Text Box Radius",value:50,resolution:"px"},topRight:{title:"Text Box Radius",value:50,resolution:"px"},
    bottomLeft:{title:"Text Box Radius",value:50,resolution:"px"},bottomRight:{title:"Text Box Radius",value:50,resolution:"px"}},
    borderRadius3:{title:"Image Carousel Radius",topLeft:{title:"Text Box Radius",value:0,resolution:"px"},topRight:{title:"Text Box Radius",value:10,resolution:"px"},
    bottomLeft:{title:"Text Box Radius",value:0,resolution:"px"},bottomRight:{title:"Text Box Radius",value:30,resolution:"px"}},
     item1AspectRatio:{title:"Image 2 Crop Ratio",value:4/2},
    //  borderRadius2:{title:"Title BG Radius",value:10,resolution:"%"},
    //  borderRadius3:{title:"Subtitle BG Radius",value:10,resolution:"%"},
   
    layoutBG:{title:"Layout Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
     item1BG:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
        item2BG:{title:"Carousel Background Color",color:"rgba(252, 187, 74, 1)",colors:{color10:"rgba(252, 187, 74,1)"},alpha:1},
margin:{
  title:"Set Text Box Card  Margin",
  marginTop:{title:"Top Margin",value:120,resolution:"px"},
  marginLeft:{title:"Left Margin",value:30,resolution:"px"},
  marginRight:{title:"Right Margin",value:30,resolution:"px"},
  marginBottom:{title:"Bottom Margin",value:30,resolution:"px"}},
marginItem1:{ title:"Set Title Margin",
  marginTop:{title:"Top Margin",value:100,resolution:"px"},
  marginLeft:{title:"Left Margin",value:15,resolution:"px"},
  marginRight:{title:"Right Margin",value:50,resolution:"px"},
  marginBottom:{title:"Bottom Margin",value:150,resolution:"px"}},
  marginItem2:{
  title:"Set Text Box Card  Margin",
  marginTop:{title:"Top Margin",value:100,resolution:"px"},
  marginLeft:{title:"Left Margin",value:30,resolution:"px"},
  marginRight:{title:"Right Margin",value:30,resolution:"px"},
  marginBottom:{title:"Bottom Margin",value:30,resolution:"px"}},
 layoutShadow:{title:"Card Shadow",horizontal:{title:"Horizontal",value:10,resolution:"%"},vertical:{title:"Horizontal",value:10,resolution:"%"},blur:{title:"Horizontal",value:10,resolution:"%"},spread:{title:"Horizontal",value:10,resolution:"%"},shadowColor:{title:"Design 1 Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1},inset:false}
    ,item1Shadow:{title:"Image Shadow",horizontal:{title:"Horizontal",value:1,resolution:"%"},vertical:{title:"Horizontal",value:1,resolution:"%"},blur:{title:"Horizontal",value:12,resolution:"%"},spread:{title:"Horizontal",value:2,resolution:"%"},shadowColor:{title:"Design 1 Color",color:"rgba(62, 62, 62, 0.23)",colors:{color10:"rgba(46, 46, 44, 0.23)"},alpha:1},inset:false}
    ,item2Shadow:{title:"Design 1 Shadow",horizontal:{title:"Horizontal",value:0,resolution:"%"},vertical:{title:"Horizontal",value:0,resolution:"%"},blur:{title:"Horizontal",value:0,resolution:"%"},spread:{title:"Horizontal",value:0,resolution:"%"},shadowColor:{title:"Design 1 Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1},inset:false}
  ,
 typographyTitle:{
         titleColor:{title:"Title Text Color",color:"rgba(29, 29, 29, 0.93)",colors:{color2:"rgba(29, 29, 29, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
    
        size:{title:"Title Text Font Size",value:20,resolution:"px"},
        family:{name:"OpenSans-Regular",
    fontFamily:"OpenSansRegular , sans-serif"
       },
        weight:{title:"Title Text Font Weight",fontWeight:"900"},
        textAlignment:{title:"Title Text Alignment",textAlign:"left"},
        textCase:{title:"Title Text Case",textTransform:"uppercase"},
       textStyle:{title:"Title  Text Style",textStyle:"italic"},
       decoration:{title:"Title Text Decoration",line:"",style:"solid", decorationColor :{title:"Title Text Decoration Color",color:"rgba(246, 240, 240, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},thickness:{title:"Title Text Decoration Thickness",value:5,resolution:"px"}},
       lineHeight:{title:"Title Text Line Height",value:20,resolution:"px"},
       letterSpacing:{title:"Title Text Letter Spacing",value:1,resolution:"px"},
       wordSpacing:{title:"Title Text Word Spacing",value:5,resolution:"px"},
       textStroke:{ 
         strokeColor:{title:"Title Text Stroke Color",color:"rgba(251, 247, 247, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
         strokeSize:{title:"Title Text Stroke Size",value:2,resolution:"px"},
       
              } ,
                  textShadow:{title:"Title  Text Shadow",horizontal:{title:"Title Shadow Horizontal",value:10,resolution:"%"},vertical:{title:"Title Shadow Vertical",value:10,resolution:"%"},blur:{title:"Title Shadow Blur",value:10,resolution:"%"},spread:{title:"Title Shadow Spread",value:10,resolution:"%"},shadowColor:{title:"Title Shadow Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1}}   
        
    }
    ,typographySubtitle:{
         titleColor:{title:"SubtTitle Text Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
    
        size:{title:"SubtTitle Text Font Size",value:12,resolution:"px"},
        family:{name:"OpenSans-Regular",
    fontFamily:"OpenSansRegular , sans-serif"
       },
        weight:{title:"Title Text Font Weight",fontWeight:"100"},
        textAlignment:{title:"Title Text Alignment",textAlign:"left"},
        textCase:{title:"Title Text Case",textTransform:"capitalize"},
       textStyle:{title:"Title  Text Style",textStyle:"normal"},
      decoration:{title:"Subtitle Text Decoration",line:"none",style:"wavy",
         decorationColor :{title:"Subtitle  Text Decoration Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},thickness:{title:"Subtitle  Text Decoration Thickness",value:2,resolution:"px"}},
       lineHeight:{title:"Title Text Line Height",value:30,resolution:"px"},
       letterSpacing:{title:"Title Text Letter Spacing",value:2,resolution:"px"},
       wordSpacing:{title:"Title Text Word Spacing",value:5,resolution:"px"},
       textStroke:{ 
         strokeColor:{title:"Title Text Stroke Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
         strokeSize:{title:"Title Text Stroke Size",value:0,resolution:"px"},
       
              } ,
                  textShadow:{title:"Title  Text Shadow",horizontal:{title:"Title Shadow Horizontal",value:0,resolution:"%"},vertical:{title:"Title Shadow Vertical",value:10,resolution:"%"},blur:{title:"Title Shadow Blur",value:10,resolution:"%"},spread:{title:"Title Shadow Spread",value:10,resolution:"%"},shadowColor:{title:"Title Shadow Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1}}   
        
    }
    
    
 },  }



],
        
        }
